import morgan from 'morgan';
import morganJson from 'morgan-json';

const serverHost = process.env.HOSTNAME || '';
const podNamespace = process.env.POD_NAMESPACE || '';

const format = morganJson({
  timestamp: ':date[iso]',
  remote_addr: ':remote-addr',
  response_status: ':status',
  request: ':method :url :http-version',
  api: ':url',
  request_method: ':method',
  host: ':req[host]',
  http_referrer: ':referrer',
  http_user_agent: ':req[user-agent]',
  http_version: ':http-version',
  x_forwarded_for: ':req[x-forwarded-for]',
  client_ip: ':req[x-real-ip]',
});

const logger = morgan(format);

export default function (req, res, next) {
  if (req) {
    serverHost && res.setHeader('X-Server-Host', serverHost);
    podNamespace === 'operations-fe-gray' && res.setHeader('X-vas-env', 'gray');
    logger(req, res, next);
  } else {
    next();
  }
}
